<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">직원관리</span>
            <span class="txt">현재 근무중인 직원을 확인할 수 있으며, 직원 설정이 가능합니다.</span>
        </div>
        <div class="com-search-content">
            <div class="line">
                <select-form
                    :select-data="['선택', ...chainCenterType]"
                    :select-value="['', ...chainCenterTypeValue]"
                    :selected-value="chainCenter"
                    @update:set="(val) => (chainCenter = val)"
                />
                <select-form
                    :select-data="['선택', ...statusType]"
                    :select-value="['', ...statusTypeValue]"
                    :selected-value="status"
                    @update:set="(val) => (status = val)"
                />
                <select-form
                    :select-data="['선택', ...centerTeamIdType]"
                    :select-value="['', ...centerTeamIdTypeValue]"
                    :selected-value="centerTeamId"
                    @update:set="(val) => (centerTeamId = val)"
                />
                <button class="com-search-reset" @click="resetSearchParams"></button>
                <div class="com-search-input">
                    <input v-model="searchStr" placeholder="이름 입력" type="text" v-on:keyup.enter="onEventSearch" />
                    <button class="search-btn" @click="onEventSearch">검색</button>
                </div>
            </div>
        </div>
        <div class="com-btn-area">
            <div class="right-box">
                <router-link class="com-btn blue" to="/madmin/setting/employee/info">등록</router-link>
            </div>
        </div>

        <loading-spinner v-if="isLoading"></loading-spinner>
        <div v-else class="employee-card-list">
            <ul class="select-photo-list">
                <li v-for="(employee, index) in employeeList">
                    <router-link :key="index" :to="`/madmin/setting/employee/info/${employee.staffId}`">
                        <img
                            :src="employee.imgUrl === null ? '/img/temp/no_photo.jpg' : employee.imgUrl"
                            alt=""
                            @error="imageUrlAlt"
                        />
                        <span class="name">{{ employee.name }}</span>
                        <span class="tel">{{ employee.phone | phoneNumberFilter }}</span>
                        <span class="type">{{ employee.roleName === null ? '-' : employee.roleName }}</span>
                        <span class="detail">{{ employee.staffTeams }}</span>
                    </router-link>
                </li>
            </ul>
            <p v-if="employeeList.length === 0" class="no-msg">소속된 직원이 없습니다.</p>
        </div>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import LoadingSpinner from '@/components/LoadingSpinner.vue';
import EventBus from '../../../assets/js/eventBus';
import { pagingInfo } from '@/assets/js/common';

export default {
    name: 'SettingEmployeeList',
    components: { LoadingSpinner },
    props: {},
    computed: {
        cId() {
            const { getters } = this.$store;
            return getters['auth/cId'];
        },
    },
    watch: {
        chainCenter(newValue) {
            this.fetchEmployeeList();
        },
        status(newValue) {
            this.fetchEmployeeList();
        },
        centerTeamId(newValue) {
            this.fetchEmployeeList();
        },
    },
    async mounted() {
        this.loginCenterId = parseInt(this.cId); // 로그인한 사용자의 센터 Id
        this.centerTeamId = this.$route.query.centerTeamId || '';
        this.status = this.$route.query.status || 'I';
        await this.init();
        this.chainCenter =
            this.$route.query.chainCenter || this.chainCenterTypeValue[this.chainCenterTypeValue.length - 1];
    },
    data() {
        return {
            isLoading: false,
            loginCenterId: '',
            employeeListInfo: [], // 데이터 가공 전
            employeeList: [], // 데이터 가공 후
            pagingInfo: { ...pagingInfo },
            searchStr: '', // 이름, 닉네임 검색 키워드
            status: 'I',
            centerTeamId: '',
            chainCenter: '',

            chainCenterType: [],
            chainCenterTypeValue: [],
            statusType: ['근무중인 직원', '퇴사한 직원'],
            statusTypeValue: ['I', 'O'],
            centerTeamIdType: [],
            centerTeamIdTypeValue: [],
        };
    },
    methods: {
        // 초기화
        async init() {
            await this.fetchCenterTeam(); // 센터의 팀 목록 조회
            await this.fetchChainCenter(); // 소속 체인점 센터 조회
        },

        // staff image 없을 경우 default image 표시
        imageUrlAlt(event) {
            event.target.src = '/img/temp/no_photo.jpg';
        },

        // 직원 목록 fetch
        async fetchEmployeeList() {
            try {
                this.employeeListInfo = [];
                this.employeeList = [];
                this.pagingInfo.limit = 10000;
                this.isLoading = true;

                const centerId = this.chainCenter || this.loginCenterId;
                const { data } = await api.get(`/admin/api/center/${centerId}/staff/all/pagaing`, {
                    params: {
                        ...this.pagingInfo,
                        searchStr: this.searchStr,
                        status: this.status,
                        centerTeamId: this.centerTeamId,
                    },
                });

                this.employeeListInfo = data.items;
                this.employeeListInfo.forEach((e) => {
                    const temp = {
                        name: e.c_namee,
                        phone: e.c_phone,
                        roleName: e.r_role_nm,
                        staffId: e.c_center_staff_id,
                        imgUrl: e.c_img_url,
                        staffTeams: '',
                    };
                    if (e.centerStaffTeams.length === 1) {
                        e.centerStaffTeams[0].centerTeam !== null
                            ? (temp.staffTeams = e.centerStaffTeams[0].centerTeam.name)
                            : (temp.staffTeams = '-');
                    } else if (e.centerStaffTeams.length === 0) {
                        temp.staffTeams = '-';
                    } else {
                        try {
                            temp.staffTeams = `${e.centerStaffTeams[0].centerTeam.name} 외 ${
                                e.centerStaffTeams.length - 1
                            }`;
                        } catch (e) {
                            temp.staffTeams = '-';
                        }
                    }
                    this.employeeList.push(temp);
                });

                this.isLoading = false;
            } catch (error) {
                console.log(error);
                alert('직원 목록을 가져오는 중 오류가 발생했습니다.');
            }
        },

        // 이벤트 발생시 키워드 길이 체크
        onEventSearch(e) {
            if (this.searchStr.length < 2) {
                return;
            }
            if (this.searchStr === '' || this.searchStr.length > 1) {
                this.fetchEmployeeList(this.loginCenterId);
            }
        },

        // 센터팀 조회
        async fetchCenterTeam() {
            try {
                const { data } = await this.sendGetCenterTeam(this.loginCenterId);
                data.forEach((c) => {
                    this.centerTeamIdType.push(c.name);
                    this.centerTeamIdTypeValue.push(c.centerTeamId);
                });
            } catch (error) {
                alert('센터팀 정보를 가져오는 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 센터팀 조회 API
        sendGetCenterTeam(centerId) {
            return api.get(`/admin/api/center/${centerId}/team`);
        },

        // 소속 체인점 센터 조회
        async fetchChainCenter() {
            try {
                const { data } = await this.sendGetChainCenter();
                // this.chainCenterType = data;
                // this.chainCenterTypeValue;
                data.forEach((c) => {
                    this.chainCenterType.push(c.centerName);
                    this.chainCenterTypeValue.push(c.id);
                });
            } catch (error) {
                console.log(error);
            }
        },

        // 소속 체인점 센터 조회 API 호출
        sendGetChainCenter() {
            let centerId;
            this.chainCenter === '' ? (centerId = this.loginCenterId) : (centerId = this.chainCenter);
            return api.get(`/admin/api/center/${centerId}/chain`);
        },

        // 검색 조건 초기화
        resetSearchParams() {
            this.status = ''; // 근무중 직원, 퇴사한 직원 파라미터
            this.centerTeamId = ''; // 팀 파라미터
            this.searchStr = ''; // 이름 파라미터

            EventBus.$emit('event:initList', 'init');
        },
    },
};
</script>
<style lang="scss"></style>
